module.exports = __webpack_public_path__ + "images/illustrations/illustration-rise-cloud-3-2d98bd2d02457f6bf6526c553fa1de3e.webp";